import {Col, Row} from 'react-bootstrap';
const TestimonialsBlock = ({ block }) => {
    return (
      <div className="row text-center">
        <h3>Testimonials</h3>
        {block.columns.map((column, index) => (
          <Col key={index} className='col-md-3'>
            {column}
          </Col>
        ))}
      </div>
    );
  };

export default TestimonialsBlock;